// Onglets d'informations sous la fiche produit (Description, Livraison, etc.).
if (!customElements.get('hf-details-tabs')) {
  customElements.define(
    'hf-details-tabs',
    class HfDetailsTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            const last = this.tabs.length - 1;
            if (event.key === 'ArrowRight') this.select(index === last ? 0 : index + 1, true);
            else if (event.key === 'ArrowLeft') this.select(index === 0 ? last : index - 1, true);
          });
        });
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected);
          tab.tabIndex = selected ? 0 : -1;
          document.getElementById(tab.getAttribute('aria-controls')).hidden = !selected;
        });
        if (focus) this.tabs[index].focus();
      }
    }
  );
}
